import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckedSuccessIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.4571 16.0429C11.0666 15.6524 10.4334 15.6524 10.0429 16.0429C9.65237 16.4334 9.65237 17.0666 10.0429 17.4571L10.75 16.75L11.4571 16.0429ZM13.75 19.75L13.0429 20.4571C13.4334 20.8476 14.0666 20.8476 14.4571 20.4571L13.75 19.75ZM21.9571 12.9571C22.3476 12.5666 22.3476 11.9334 21.9571 11.5429C21.5666 11.1524 20.9334 11.1524 20.5429 11.5429L21.25 12.25L21.9571 12.9571ZM31 16H30C30 23.732 23.732 30 16 30V31V32C24.8366 32 32 24.8366 32 16H31ZM16 31V30C8.26801 30 2 23.732 2 16H1H0C0 24.8366 7.16344 32 16 32V31ZM1 16H2C2 8.26801 8.26801 2 16 2V1V0C7.16344 0 0 7.16344 0 16H1ZM16 1V2C23.732 2 30 8.26801 30 16H31H32C32 7.16344 24.8366 0 16 0V1ZM10.75 16.75L10.0429 17.4571L13.0429 20.4571L13.75 19.75L14.4571 19.0429L11.4571 16.0429L10.75 16.75ZM13.75 19.75L14.4571 20.4571L21.9571 12.9571L21.25 12.25L20.5429 11.5429L13.0429 19.0429L13.75 19.75Z",
		fill: "#6FCF97"
	})
});
export default SvgCheckedSuccessIcon;
